import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

const AdmInventoryCategory = () => {
  const navigate = useNavigate();
  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");
  const userId = sessionStorage.getItem("userId");

  // Category Form State
  const [categoryName, setCategoryName] = useState("");
  const [editingCategoryId, setEditingCategoryId] = useState(null);

  // Sub-Category Form State
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subCategoryName, setSubCategoryName] = useState("");
  const [enabled, setEnabled] = useState(true);
  const [editingSubCategoryId, setEditingSubCategoryId] = useState(null);

  // Lists State
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch Category List
  const fetchCategories = async () => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}INVENTORY/categories/?org_id=${orgId}&branch_id=${branchId}`
      );
      const data = await response.json();
      if (response.ok) {
        setCategories(data);
      } else {
        console.error("Error fetching categories:", data);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  // Fetch Sub-Category List
  const fetchSubCategories = async () => {
    try {
      const response = await fetch(
        `${ApiUrl.apiurl}INVENTORY/subcategories/?org_id=${orgId}&branch_id=${branchId}`
      );
      const data = await response.json();
      if (response.ok) {
        setSubCategories(data);
      } else {
        console.error("Error fetching sub-categories:", data);
      }
    } catch (error) {
      console.error("Error fetching sub-categories:", error);
    }
  };

  useEffect(() => {
    if (orgId && branchId) {
      fetchCategories();
      fetchSubCategories();
    }
  }, [orgId, branchId]);

  // Handle Save Category
  const handleSaveCategory = async (e) => {
    e.preventDefault();
    if (!categoryName.trim()) {
      alert("Please enter a category name.");
      return;
    }

    const payload = {
      category_name: categoryName.trim(),
      orgId: orgId,
      branchId: branchId,
      created_by: userId || 1,
      is_active: true,
    };

    setLoading(true);
    try {
      const url = editingCategoryId
        ? `${ApiUrl.apiurl}INVENTORY/categories/${editingCategoryId}/`
        : `${ApiUrl.apiurl}INVENTORY/categories/`;
      const method = editingCategoryId ? "PUT" : "POST";

      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (response.ok) {
        alert(`Category ${editingCategoryId ? "updated" : "saved"} successfully!`);
        setCategoryName("");
        setEditingCategoryId(null);
        fetchCategories();
      } else {
        alert("Error: " + JSON.stringify(result));
      }
    } catch (error) {
      console.error("Save category error:", error);
      alert("An error occurred while saving the category.");
    } finally {
      setLoading(false);
    }
  };

  // Handle Save Sub-Category
  const handleSaveSubCategory = async (e) => {
    e.preventDefault();
    if (!selectedCategory) {
      alert("Please select a category.");
      return;
    }
    if (!subCategoryName.trim()) {
      alert("Please enter a sub-category name.");
      return;
    }

    const payload = {
      category: selectedCategory.value,
      subcategory_name: subCategoryName.trim(),
      enabled: enabled ? "Y" : "N",
      created_by: userId || 1,
      is_active: true,
    };

    setLoading(true);
    try {
      const url = editingSubCategoryId
        ? `${ApiUrl.apiurl}INVENTORY/subcategories/${editingSubCategoryId}/`
        : `${ApiUrl.apiurl}INVENTORY/subcategories/`;
      const method = editingSubCategoryId ? "PUT" : "POST";

      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (response.ok) {
        alert(`Sub-Category ${editingSubCategoryId ? "updated" : "saved"} successfully!`);
        setSubCategoryName("");
        setSelectedCategory(null);
        setEnabled(true);
        setEditingSubCategoryId(null);
        fetchSubCategories();
      } else {
        alert("Error: " + JSON.stringify(result));
      }
    } catch (error) {
      console.error("Save sub-category error:", error);
      alert("An error occurred while saving the sub-category.");
    } finally {
      setLoading(false);
    }
  };

  // Edit action
  const handleEditSubCategory = (sub) => {
    setEditingSubCategoryId(sub.subcategory_id);
    setSelectedCategory({
      value: sub.category,
      label: sub.category_name,
    });
    setSubCategoryName(sub.subcategory_name);
    setEnabled(sub.enabled === "Y");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Clear Form fields
  const handleClear = () => {
    setCategoryName("");
    setEditingCategoryId(null);
    setSelectedCategory(null);
    setSubCategoryName("");
    setEnabled(true);
    setEditingSubCategoryId(null);
  };

  const categoryOptions = categories.map((cat) => ({
    value: cat.category_id,
    label: cat.category_name,
  }));

  const filterPanelStyle = {
    backgroundColor: "#ffffff",
    border: "1px solid #dee2e6",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  };

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card p-0 ">
            <div className="card-body">
              {/* Page Title */}
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                INVENTORY CATEGORY
              </p>

              {/* Action Buttons */}
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              {/* Forms Row */}
              <div className="row mx-0 mb-3">
                {/* Form 1: Add Inventory Category */}
                <div className="col-12 col-md-6 mb-3">
                  <div className="p-3 rounded" style={filterPanelStyle}>
                    <p className="fw-bold mb-3" style={{ fontSize: "17px" }}>
                      Add Inventory Category
                    </p>
                    <form onSubmit={handleSaveCategory}>
                      <div className="mb-3">
                        <label className="form-label fw-bold">
                          Enter Category <span className="text-danger">*</span>
                        </label>
                        <div className="d-flex gap-2">
                          <input
                            type="text"
                            className="form-control detail"
                            placeholder="Enter category name"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                          />
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px" }}
                            disabled={loading}
                          >
                            {editingCategoryId ? "Update" : "Save"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Form 2: Add Inventory Sub-Category */}
                <div className="col-12 col-md-6 mb-3">
                  <div className="p-3 rounded" style={filterPanelStyle}>
                    <p className="fw-bold mb-3" style={{ fontSize: "17px" }}>
                      Add Inventory Sub-Category
                    </p>
                    <form onSubmit={handleSaveSubCategory}>
                      <div className="mb-3">
                        <label className="form-label fw-bold">
                          Select Category <span className="text-danger">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          value={selectedCategory}
                          className="detail"
                          onChange={(option) => setSelectedCategory(option)}
                          placeholder="Select Categories"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label fw-bold">
                          Sub-Category <span className="text-danger">*</span>
                        </label>
                        <div className="d-flex gap-2 align-items-center">
                          <input
                            type="text"
                            className="form-control detail"
                            placeholder="Enter sub-category name"
                            value={subCategoryName}
                            onChange={(e) => setSubCategoryName(e.target.value)}
                          />
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px" }}
                            disabled={loading}
                          >
                            {editingSubCategoryId ? "Update" : "Save"}
                          </button>
                        </div>
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="enabledCheck"
                          checked={enabled}
                          onChange={(e) => setEnabled(e.target.checked)}
                        />
                        <label
                          className="form-check-label fw-bold"
                          htmlFor="enabledCheck"
                        >
                          Enabled
                        </label>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* Inventory Category List Table */}
              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Category</th>
                        <th>Sub-Category</th>
                        <th>Active</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {subCategories.length === 0 ? (
                        <tr>
                          <td
                            colSpan="5"
                            className="text-center text-muted py-3"
                          >
                            No records found
                          </td>
                        </tr>
                      ) : (
                        subCategories.map((sub, index) => (
                          <tr key={sub.subcategory_id}>
                            <td className="text-center">{index + 1}</td>
                            <td>{sub.category_name}</td>
                            <td>{sub.subcategory_name}</td>
                            <td className="text-center">{sub.enabled}</td>
                            <td className="text-center">
                              <button
                                type="button"
                                className="btn btn-link text-decoration-none p-0 fw-semibold"
                                onClick={() => handleEditSubCategory(sub)}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmInventoryCategory;

